import Vue from "vue";
import Vuex from "vuex";
import global from "./modules/global";
import permissions from "./modules/permissions";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    global,
    permissions,
  },
});

export default store;
